import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-voxr',
  templateUrl: './voxr.component.html',
  styleUrls: ['./voxr.component.scss']
})
export class VoxrComponent implements OnInit {

  @Input() voxrEventID: string;

  constructor() { }

  url: string;

  ngOnInit(): void {
    this.url = 'https://voxr.com/' + this.voxrEventID + '?iframe=true&inapp=';
  }

}
